'use strict';

var _ = require('lodash');
var MarketAnalysisController = function MarketAnalysisController($scope, $rootScope, restangular, dataService, marketAnalysisPanelService, currentStateCriteriaService, scenarioService, userPreferencesService, dataRetrieverService, dataRetrieverConstantsService, navigationHistoryService, featureToggleService, demandPostingService, referenceValueToggleService, pooledSeasonalityReviewConstants) {
  $scope.availableModes = ['market', 'market-product-group', 'service'];
  $scope.mode = $scope.availableModes[0];
  $scope.screen = dataRetrieverConstantsService.MARKET_SCREEN;
  $scope.showMarketAnalysisMode = false;
  $scope.showMarketProductGroupMode = false;
  $scope.showServiceAnalysisMode = false;
  $scope.buildMarketAnalysisMode = false;
  $scope.buildMarketProductGroupMode = false;
  $scope.buildServiceAnalysisMode = false;
  $scope.marketProductSearchData = {};
  $scope.serviceSearchData = {};
  $scope.isPooledSeasonalityEnabled = false;
  $scope.demandPostingPanel = {
    visible: false,
    contextData: {}
  };
  $scope.demandTransparencyPanel = {
    visible: false,
    contextData: {}
  };
  $scope.screenState = {
    dataRepresentation: userPreferencesService.getUserSettingComponent('defaultDataRepresentation') || 'absolute',
    dimension: featureToggleService.isEnabled('MAPPED_MODE') ? 'regular' : 'mapped',
    metric: undefined,
    selectedReference: undefined,
    referenceValueModes: undefined,
    searchReady: true,
    isMarketAnalysisGridExpanded: userPreferencesService.getUserSettingComponent('isMarketAnalysisGridExpanded') || false
  };
  $scope.$on('gridExpand:market-demand-analysis', function () {
    $scope.screenState.isMarketAnalysisGridExpanded = !$scope.screenState.isMarketAnalysisGridExpanded;
  });
  $scope.scenarioName = scenarioService.getSelectedScenarioName();
  $scope.reoptPreviewData = {
    flightDetails: {}
  };
  var dateChartData;
  var lastBrushes;
  var lastSelectedGridRows;
  $scope.toggleReferenceValueDisabled = function (value, isDisabled) {
    var mode = _.find($scope.screenState.referenceValueModes, {
      value: value
    });
    if (_.isNil(mode) || mode.disabled === isDisabled) {
      return;
    }
    mode.disabled = isDisabled;
    if (mode.selected && isDisabled) {
      mode.selected = false;
      var defaultReference = _.first($scope.screenState.referenceValueModes);
      defaultReference.selected = true;
      $scope.screenState.selectedReference = defaultReference.value;
    }
  };
  $scope.updateReferenceDisabledStatus = function () {
    if (!$scope.screenState.referenceValueModesAvailable) {
      return;
    }
    var isSeasonAvgDisabled = $scope.mode === 'service';
    $scope.toggleReferenceValueDisabled('seasonalAverage', isSeasonAvgDisabled);
  };
  $scope.resetReferenceValueModes = function (forcedSelection) {
    var referenceValueProperties = referenceValueToggleService.getInitialReferenceValues(forcedSelection);
    $scope.screenState = _.extend($scope.screenState, referenceValueProperties);
  };
  $scope.updateReferenceValueModes = function (forcedSelection) {
    if (_.isNil($scope.screenState.referenceValueModes)) {
      $scope.resetReferenceValueModes(forcedSelection);
    }
    $scope.updateReferenceDisabledStatus();
  };
  $scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
    navigationHistoryService.setPreviousMode($scope.mode, function (mode) {
      $scope.buildServiceAnalysisMode = false;
      $scope.buildMarketProductGroupMode = false;
      $rootScope.$broadcast('market-analysis-toggle:invoke', mode);
    });
    $scope.mode = mode;
    $scope.showMarketAnalysisMode = $scope.mode === $scope.availableModes[0];
    $scope.showMarketProductGroupMode = $scope.mode === $scope.availableModes[1];
    $scope.showServiceAnalysisMode = $scope.mode === $scope.availableModes[2];
    $scope.buildMarketAnalysisMode = $scope.showMarketAnalysisMode || $scope.buildMarketAnalysisMode;
    $scope.buildMarketProductGroupMode = $scope.showMarketProductGroupMode || $scope.buildMarketProductGroupMode;
    $scope.buildServiceAnalysisMode = $scope.showServiceAnalysisMode || $scope.buildServiceAnalysisMode;
    $scope.updateReferenceValueModes();
  });
  $scope.$on('prepareTabsToReloadDataOnToggle', function (event, marketAnalysisMode, marketProductMode) {
    $scope.buildMarketAnalysisMode = marketAnalysisMode;
    $scope.buildMarketProductGroupMode = marketProductMode;
  });
  $scope.$on('search-criteria:searchChangeEvent', function () {
    dataService.clearCache();
  });
  $scope.$on('scenarios:saved', function (event, gridId) {
    if ('market-product-group-analysis' === gridId || 'service-demand-analysis' === gridId) {
      dataService.clearCache();
    }
  });
  $scope.$on('demand-posting:swap', function ($event, isShown, contextData) {
    $scope.demandPostingPanel.contextData = contextData;
    $scope.demandPostingPanel.visible = isShown;
    demandPostingService.scrollDown('[mode="' + $scope.mode + '"] .rm-grid-panel', isShown);
  });
  $scope.$on('demand-transparency:swap', function ($event, isShown, contextData) {
    $scope.demandTransparencyPanel.contextData = contextData && contextData.demandData ? contextData.demandData : contextData;
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && isShown) {
      $scope.isPooledSeasonalityEnabled = true;
      $scope.screenName = pooledSeasonalityReviewConstants.SCREEN_ID_MARKET_ANALYSIS;
      $scope.demandTransparencyAttributes = contextData.demandTransparencyAttributes;
      $scope.displayedCalendar = contextData.displayedCalendar;
    }
    $scope.demandTransparencyPanel.visible = isShown;
  });
  $scope.$on('dateRangeChart:dataChanged', function ($event, datesChartData) {
    dateChartData = datesChartData;
    var dateRanges = marketAnalysisPanelService.getDateRangesForService(lastBrushes, lastSelectedGridRows, dateChartData);
    $scope.serviceSearchData.dateRanges = dateRanges.length ? dateRanges : $scope.marketProductSearchData.dateRanges;
    $scope.$broadcast('service-analysis:filterUpdated');
  });
  function isOneMarketSelected() {
    return _.get($scope.marketProductSearchData, 'markets.length') === 1;
  }
  $scope.updateMarketProductFilterData = function (brushes, selectedGridRows) {
    $scope.marketProductSearchData.markets = marketAnalysisPanelService.getMarket(brushes, selectedGridRows);
    $scope.marketProductSearchData.poses = marketAnalysisPanelService.getPoses(brushes, selectedGridRows);
    $scope.marketProductSearchData.daysOfWeek = marketAnalysisPanelService.getDaysOfWeek(brushes, selectedGridRows);
    $scope.marketProductSearchData.dateRanges = marketAnalysisPanelService.getDateRanges(brushes, selectedGridRows);
    $scope.serviceSearchData = _.clone($scope.marketProductSearchData);
    $rootScope.$broadcast('market-product-group:filterUpdated', isOneMarketSelected());
    $scope.$broadcast('service-analysis:filterUpdated');
  };
  $scope.updateServiceFilterData = function (brushes, selectedGridRows) {
    lastBrushes = brushes;
    lastSelectedGridRows = selectedGridRows;
    var poses = marketAnalysisPanelService.getPoses(brushes, selectedGridRows);
    var markets = marketAnalysisPanelService.getMarket(brushes, selectedGridRows);
    $scope.serviceSearchData.poses = poses.length ? poses : $scope.marketProductSearchData.poses;
    $scope.serviceSearchData.markets = _.size(markets) ? markets : $scope.marketProductSearchData.markets;
    var daysOfWeek = marketAnalysisPanelService.getDaysOfWeek(brushes, selectedGridRows);
    $scope.serviceSearchData.daysOfWeek = daysOfWeek.length ? daysOfWeek : $scope.marketProductSearchData.daysOfWeek;
    var dateRanges = marketAnalysisPanelService.getDateRangesForService(brushes, selectedGridRows, dateChartData);
    $scope.serviceSearchData.dateRanges = dateRanges.length ? dateRanges : $scope.marketProductSearchData.dateRanges;
    $scope.serviceSearchData.serviceClasses = marketAnalysisPanelService.getServiceClasses(brushes, selectedGridRows);
    $scope.serviceSearchData.gridSelectionKeysMap = marketAnalysisPanelService.buildServiceShareSelectionKeysMap(selectedGridRows);
    $scope.$broadcast('service-analysis:filterUpdated');
  };
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    var transitionScreenState = _.get(toParams, ['transitionData', 'screenState']);
    if (transitionScreenState) {
      $scope.screenState.metric = transitionScreenState.selectedMetric;
      $scope.screenState.dimension = transitionScreenState.dataDimension;
      $scope.screenState.dataRepresentation = transitionScreenState.dataRepresentation;
      $scope.updateReferenceValueModes(transitionScreenState.selectedReference);
    }
  });
  $scope.$on('cog:date-range-chart', function (event, value) {
    $scope.screenState.dataRepresentation = value.val[0];
  });
  $scope.$on('cog:marketAnalysisToolbar', function (event, dimension) {
    $scope.screenState.dimension = dimension.val[0];
  });
  $scope.$on('scenarios:changed', function () {
    dataService.clearCache();
    $scope.scenarioName = scenarioService.getSelectedScenarioName();
    var scenarios = $scope.scenarioName ? [scenarioService.PUBLISHED, $scope.scenarioName] : [scenarioService.PUBLISHED];
    dataRetrieverService.setScenarios(scenarios, $scope.screen);
    $scope.$broadcast($scope.screen + ':scenariosChanged');
  });
};
MarketAnalysisController.$inject = ['$scope', '$rootScope', 'Restangular', 'DataService', 'MarketAnalysisPanelService', 'CurrentStateCriteriaService', 'ScenarioService', 'UserPreferencesService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'NavigationHistoryService', 'FeatureToggleService', 'DemandPostingService', 'ReferenceValueToggleService', 'PooledSeasonalityReviewConstants'];
module.exports = MarketAnalysisController;